import { IStorageAccessor } from 'util/domain';

export interface IPinRepository {
    get(pinToken:string): any;
    set(pinToken:string, authData:any): void;
    has(pinToken:string): boolean;
    clear():void;
}

const storageKey = 'sb-pin-data';
export class PinRepository implements IPinRepository{
    static $inject = ['sessionStorageService'];
    private tokensStored:string[] = [];

    constructor(private sessionStorageService:IStorageAccessor){
    }

    public get(pinToken:string){
        var dataString = this.sessionStorageService.getStoredValue(genKey(pinToken));
        if(dataString) {
            return JSON.parse(dataString);
        }
    }   

    public set(pinToken:string, authData:any){
        if(!authData){
            throw new Error('Serializable data required.');
        }
        
        this.tokensStored.push(pinToken);
        this.sessionStorageService.setStoredValue(genKey(pinToken), JSON.stringify(authData));
    }

    public has(pinToken:string){
        return !!this.sessionStorageService.getStoredValue(genKey(pinToken));
    }

    public clear() {
        this.tokensStored.forEach(function(token){
            sessionStorage.removeItem(genKey(token));
        });
        this.tokensStored = [];
    }
}

function genKey(pinToken){
    return `${storageKey}:${pinToken}`;
}


// WEBPACK FOOTER //
// ./src/sharebase/services/pinRepoService.ts